import { Diamond, Heart, Sparkles } from "lucide-react";

export const MISSION_INFO = {
  marriage: { label: "Marriage", Icon: Diamond, request: "courtship", button: "Request Courtship", text: "You are ready for a committed relationship that leads to marriage." },
  dating: { label: "Dating", Icon: Heart, request: "dating", button: "Request Dating", text: "You want to date with intention and see where a connection can grow." },
  flirtation: { label: "Flirtation", Icon: Sparkles, request: "flirtation", button: "Request Flirtation", text: "Lighthearted, friendly and respectful romantic connection between consenting adults." },
};

export const REQUEST_NOUN = {
  courtship: "Request for Courtship",
  dating: "Request for Dating",
  flirtation: "Request for Flirtation",
};

export const ROLE_LABELS = {
  super_admin: "Super admin", member_admin: "Member admin", moderator: "Moderator",
  verification_reviewer: "Verification reviewer", finance: "Finance",
};

export const REPORT_REASONS = {
  fake_profile: "Fake profile", inappropriate_photo: "Inappropriate photo", harassment: "Harassment",
  scam: "Scam / asking for money", underage: "Underage", other: "Other",
};
